import * as angular from 'angular';
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";

export interface DefectClassificationService {
  getDefectClassifications(): angular.IPromise<apsViewModels.DefectClassification[]>;
}

export default angular
  .module('aps.services.defectClassification', [HttpServiceName])
  .service('defectClassificationService',
    function (httpService: HttpService): DefectClassificationService {

      let getDefectClassifications = () =>
        httpService.get<apsViewModels.DefectClassification[]>(Endpoints.DEFECT_CLASSIFICATION_LIST);

      return {
        getDefectClassifications: getDefectClassifications
      };
    })
  .name;



// WEBPACK FOOTER //
// ./src/app/services/defects/defectClassification.service.ts